import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore.js";
import { useI18n } from "../i18n/index.js";

export function LogoutPage() {
  const { logout } = useAuthStore();
  const navigate = useNavigate();
  const { t } = useI18n();
  const didLogout = useRef(false);

  useEffect(() => {
    if (!didLogout.current) {
      didLogout.current = true;
      logout();
    }
  }, [logout]);

  return (
    <div className="min-h-screen bg-[var(--table-bg)] flex items-center justify-center text-white p-4">
      <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20 shadow-2xl w-full max-w-xs">
        <p className="text-4xl mb-3">👋</p>
        <h1 className="text-xl font-bold mb-2">{t("logout.title")}</h1>
        <p className="text-white/50 text-sm mb-6">{t("logout.subtitle")}</p>
        <button
          onClick={() => navigate("/login")}
          className="w-full px-6 py-2.5 rounded-lg bg-white/20 hover:bg-white/30 text-sm font-medium transition-colors"
        >
          {t("logout.continue")}
        </button>
      </div>
    </div>
  );
}
